var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.971,
    height: 14.055,
    viewBox: "0 0 13.971 14.055",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M10.821,12.735c-.084-.069-.156-.147-.23-.222-2.1-2.1-2.775-2.777-4.111-4.119-1.373,1.37-2.066,2.064-4.189,4.193a1.269,1.269,0,0,1-.984.448,1.305,1.305,0,0,1-1.176-.8,1.157,1.157,0,0,1,.186-1.319,2.857,2.857,0,0,1,.223-.227c2.1-2.1,2.773-2.781,4.109-4.119l.039-.04-.039-.039.006,0C3.279,5.113,2.584,4.418.459,2.293A1.287,1.287,0,0,1,.01,1.308,1.325,1.325,0,0,1,.815.127,1.151,1.151,0,0,1,2.131.317a2.347,2.347,0,0,1,.232.218c2.094,2.1,2.775,2.777,4.115,4.12C7.846,3.285,8.541,2.59,10.664.46a1.283,1.283,0,0,1,.984-.449,1.312,1.312,0,0,1,1.174.806,1.153,1.153,0,0,1-.184,1.319,2.768,2.768,0,0,1-.225.231C10.321,4.464,9.643,5.145,8.3,6.483l-.041.041.041.042h0c1.373,1.37,2.066,2.064,4.193,4.193a1.277,1.277,0,0,1,.449.981,1.318,1.318,0,0,1-.807,1.18,1.19,1.19,0,0,1-.523.127A1.248,1.248,0,0,1,10.821,12.735Z",
    transform: "translate(0.509 0.508)",
    fill: "#1a76cb",
    stroke: "#003189",
    strokeLinecap: "round",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.a3987290d05c69b713e1cd2a1dc64a74.svg";
export { ForwardRef as ReactComponent };